'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(props) {
  var text = props.text;
  var components = props.components;


  return _react2.default.createElement(
    'div',
    { className: styles.loginForm },
    _react2.default.createElement(
      'h2',
      { className: styles.title },
      'Sign In'
    ),
    _react2.default.createElement(
      'label',
      { htmlFor: 'username', className: styles.label },
      'User Name'
    ),
    _react2.default.createElement(
      EnterpriseButton,
      {
        className: styles.button,
        size: BTN_SIZES.BIG,
        type: BTN_TYPES.PRIMARY,
        onClick: this._onSubmit
      },
      'SIGN IN'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/Footer/Footer.jsx
// module id = 1459
// module chunks = 0